// client/src/lib/registration-utils.ts

export type RegStatusKind = 'paid' | 'pending' | 'review' | 'revision_requested' | 'rejected' | 'approved_to_pay' | 'material_uploaded' | 'credential_issued' | 'unknown';

export interface RegStatusInfo {
    label: string;
    kind: RegStatusKind;
    showCheck?: boolean;
}

/**
 * Determina si un estado técnico equivale a un registro pagado/confirmado.
 */
export const isPaidStatus = (status: string): boolean => {
    return ['PAID', 'CREDENTIAL_ISSUED', 'MATERIAL_UPLOADED'].includes(status);
};

/**
 * Retorna la información semántica y etiquetas de un estado de registro.
 * No contiene lógica de estilos ni Tailwind.
 */
export const getRegStatusInfo = (status: string): RegStatusInfo => {
    switch (status) {
        case 'PENDING':
            return { label: 'Pendiente', kind: 'pending' };
        case 'PAID':
            return { label: 'Pagado', kind: 'paid', showCheck: true };
        case 'MATERIAL_UPLOADED':
            return { label: 'Material Recibido', kind: 'material_uploaded', showCheck: true };
        case 'CREDENTIAL_ISSUED':
            return { label: 'Credencial Emitida', kind: 'credential_issued', showCheck: true };
        case 'APPROVED_TO_PAY':
            return { label: 'Aprobado p/Pago', kind: 'approved_to_pay' };
        case 'REJECTED':
            return { label: 'Rechazado', kind: 'rejected' };
        case 'PENDING_REVIEW':
            return { label: 'En Revisión', kind: 'review' };
        case 'REVISION_REQUESTED':
            return { label: 'CorrecciÃ³n solicitada', kind: 'revision_requested' };
        default:
            return { label: status, kind: 'unknown' };
    }
};

export const isPendingReviewState = (status: string): boolean => {
    const info = getRegStatusInfo(status);
    return info.kind === 'pending' || info.kind === 'review';
};

export const canGenerateSpeakerMagicLink = (status: string): boolean => {
    const info = getRegStatusInfo(status);
    return info.kind === 'paid';
};

export const hasSpeakerMaterialUploaded = (status: string): boolean => {
    return ['MATERIAL_UPLOADED', 'CREDENTIAL_ISSUED'].includes(status);
};

export const isReviewedState = (status: string): boolean => {
    const info = getRegStatusInfo(status);
    return info.kind === 'approved_to_pay' || info.kind === 'rejected';
};
